module.exports = __webpack_public_path__ + "static/media/state-planet-14.82d2f8c4.png";